/**
 * Runtime globals missing in Hermes (React Native release engine), CORE-343.
 *
 * Standalone native builds run on Hermes, which — unlike a browser or the Metro
 * dev runtime — does not define `DOMException`. Parts of the WebRTC / livekit
 * stack reference it at module-load time, so in a release build the bundle
 * throws `ReferenceError: Property 'DOMException' doesn't exist` before
 * `AppRegistry.registerComponent` runs → the app hangs on the splash screen.
 *
 * This module is imported FIRST in index.ts (ES imports are hoisted and
 * evaluated in order, so this runs before App's module graph loads). Guarded, so
 * it's a no-op on web / anywhere the global already exists.
 */
if (typeof (globalThis as any).DOMException === 'undefined') {
  class DOMException extends Error {
    constructor(message?: string, name?: string) {
      super(message);
      this.name = name || 'Error';
    }
  }
  (globalThis as any).DOMException = DOMException;
}

export {};
